<template lang="pug">
  .wardrobe-materials
    vue-good-table(
      :columns="columns"
      :rows="materials"
      :sort-options=`{
        enabled: true,
        initialSortBy: {field: 'serialNumber', type: 'asc'}
      }`
    )
      template(slot="table-row" slot-scope="props")
        span(v-if="props.column.field == 'materialAmount'")
          | {{ props.row.materialAmount | float }}
</template>

<script>
export default {
  props: {
    materials: {
      required: true,
      type: Array
    }
  },

  data() {
    return {
      columns: [
        {
          label: 'Номер п/п',
          field: 'serialNumber',
          type: 'number',
          sortable: false
        },
        {
          label: 'Тип детали и ее размеры',
          field: 'detailName',
          sortable: false
        },
        {
          label: 'Материал',
          field: 'materialName',
          sortable: false
        },
        {
          label: 'Единица измерения',
          field: 'unitName',
          sortable: false
        },
        {
          label: 'Кол-во элементов, шт.',
          field: 'quantity',
          type: 'number',
          sortable: false
        },
        {
          label: 'Общее кол-во БЕЗ запаса',
          field: 'materialAmount',
          type: 'number',
          sortable: false
        }
      ]
    };
  }
};
</script>
